module.exports = __webpack_public_path__ + "img/respirayoga-logo.ef671087.png";